<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>Calendar</h1>
<main class="corporate-calendar">
    <div class="p-col-12" style="margin-bottom:10px;">
      <p-dropdown [options]="calendarType" placeholder="Select..." [(ngModel)]="selectedCalendarType"></p-dropdown>
    </div>
  <app-calendar *ngIf="selectedCalendarType" [calendarType]="selectedCalendarType" [calendarYear]="calendarYear"> </app-calendar>
</main>
